import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

import { FormStore } from '../../common/form.store';
import { AnswerTypeComponent } from '../answer-type.component';
import { InputContentDataExtraValueType, InputContentDataType } from 'client/models';
import { IDataStringExtraValue } from 'common/model';

@Component({
  selector: 'answer-checkbox',
  templateUrl: './answer-checkbox.component.html',
  standalone: false
})
export class AnswerCheckboxComponent extends AnswerTypeComponent implements OnInit, OnDestroy {

  private subs = new Subscription();

  public InputContentDataExtraValueType = InputContentDataExtraValueType;

  ngOnInit() {
    super.ngOnInit();
    const sub = FormStore.reset$.subscribe(this.onReset.bind(this));
    this.subs.add(sub);

    const value: string[] | undefined = this.formControlObj.value;
    this.inputContent.inputContentDatas.forEach(inputContentDataType => {
      if (value && value.includes(inputContentDataType.value)) {
        inputContentDataType.checked = true;
      }
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  public selectOption($event, inputContentDataType: InputContentDataType) {
    const target = $event.target;
    const key = target.value;
    const optionControl = this.formControlObj as FormControl;
    const options: IDataStringExtraValue[] = optionControl.value ?? [];

    if (target.checked) {
      inputContentDataType.checked = true;
      const option = options.find(item => item.dataStringValue === inputContentDataType.key);
      if (option) {
        option.dataStringValue = key;
        option.dataStringExtraValue = inputContentDataType.extraValue;
        optionControl.setValue([...options]);
      } else {
        options.push({ dataStringValue: key, dataStringExtraValue: inputContentDataType.extraValue })
      }
      optionControl.setValue(options);
    } else {
      inputContentDataType.checked = false;
      const otherOptions = options.filter(option => option.dataStringValue !== key);
      optionControl.setValue(otherOptions);
    }
  }

  public onExtraOptionValueChange(inputContentDataType: InputContentDataType) {
    const optionControl = this.formControlObj as FormControl;
    const options: Array<IDataStringExtraValue> = optionControl.value ?? [];
    const option = options.find(item => item.dataStringValue === inputContentDataType.key);
    if (option) {
      option.dataStringExtraValue = inputContentDataType.extraValue
      optionControl.setValue([...options]);
    }
  }

  private onReset() {
    const optionControl = this.formControlObj as FormControl;
    optionControl.setValue([]);
    this.inputContent.inputContentDatas.forEach((data: InputContentDataType) => {
      data.checked = false;
    });
  }

}
